import Vue from 'vue';
import VueResource from 'vue-resource';
import moment from 'moment';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarFiltros(filtros) {
  const parametros = Object.assign({}, filtros);

  const periodo = parametros.periodo;
  delete parametros.periodo;

  if (periodo && periodo[0] && periodo[1]) {
    parametros.dataInicio = moment(periodo[0]).format('MM/DD/YYYY');
    parametros.dataFim = moment(periodo[1]).format('MM/DD/YYYY');
  }

  return parametros;
}

async function normalizarParaSalvar(provisoes) {

  var provisoesSelecionadas = "";

  for (var i = 0; i < provisoes.length; i++) {
    if (provisoes[i].selecionado == "1") {
      provisoesSelecionadas += provisoes[i].idProvisaoCrypt + ";";
    }
  }

  return provisoesSelecionadas;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({ pagina }, normalizarFiltros(filtros));

    return Vue.http.get('/api/liberarprovisoespagamento', { params: parametros }).then(response => response.data);
  },
  excel: filtros => {
    return Vue.http.get('/api/liberarprovisoespagamento/Excel',
      {
        params: normalizarFiltros(filtros),
        responseType: 'blob',
      })
      .then(response => {
        if (!response.body || response.body === '' || response.body.size === 0) return '';

        return salvarArquivo(response);
      });
  },
  liberarProvisoes: async (provisoes) => {
    provisoes = await normalizarParaSalvar(provisoes);

    return Vue.http.put(`/api/liberarprovisoespagamento/${provisoes}/liberarprovisoes`).then(res => res.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-provisoes-pagamento/servico.js